import { render } from "./BaseTableCell.vue?vue&type=template&id=cb590c66"
import script from "./BaseTableCell.vue?vue&type=script&lang=js"
export * from "./BaseTableCell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__